import { useEffect } from 'react';

import $ from 'jquery';

function useTitle(title) {
    useEffect(() => {
        document.title = title;
    }, [title]);
}


const HOST = process.env.REACT_APP_HOST;

const API_ROUTES = {
    'IS_LOGGED': HOST + '/api/house/isLogged',
    'LOGIN': HOST + '/api/login',
    'DEVICES_GET_DATA': HOST + '/api/house/devicesData',
    'DEVICES_GET_PROGS': HOST + '/api/house/devicesProgs',
    'DEVICES_CHANGE_STATE': HOST + '/api/house/changeState',
    'DEVICES_METRICS': HOST + '/api/house/deviceMetrics',
    'PROG_DISABLE_ENABLE': HOST + '/api/house/disableEnableProg',
    'PROG_SAVE': HOST + '/api/house/saveProg',
    'PROG_CANCEL': HOST + '/api/house/cancelProg',
    'VR_DATA': HOST + '/api/house/vrData',
    'VR_OPERATION': HOST + '/api/house/vrOperation',
    'ELEC_GET_CONSO': HOST + '/api/house/elecConso',
    'ELEC_SEARCH_ADR': HOST + '/api/house/elecSearchAdresse',
    'SAUTER_DEVICES_DATA': HOST + '/api/houseSauter/devicesData',
    'SAUTER_CHANGE_STATE': HOST + '/api/houseSauter/changeState',
    'SAUTER_DEVICES_PROGS': HOST + '/api/houseSauter/devicesProgs',
    'SAUTER_PROG_SAVE': HOST + '/api/houseSauter/saveProg',
    'SAUTER_PROG_CANCEL': HOST + '/api/houseSauter/cancelProg',
    'SAUTER_PROG_DISABLE_ENABLE': HOST + '/api/houseSauter/disableEnableProg',
    "SAUTER_EJP_STATES": HOST + '/api/houseSauter/ejpStates',
    "SAUTER_EJP_AUTO_STOP": HOST + '/api/houseSauter/ejpAutoStop',
    'SAUTER_ELEC_CONSOS': HOST + '/api/houseSauter/consos',
    'SAUTER_SERVICE_MAINTENANCE': HOST + '/api/houseSauter/serviceMaintenance',
}

const TRANS_SS_MODES = {
    'boost': 'Boost',
    'comfort': 'Confort',
    'eco': 'Eco',
    'frostprotection': 'Arrêt/Antigel',
}

const TRANS_SS_MODES_SAUTER = {
    'comfort': 'Confort',
    'eco': 'Eco',
    'frostprotection': 'Antigel',
    'off': 'Arrêt',
}


const TRANS_SPA_MODES = {
    'filter_3h': 'Filtration 3h',
}

function addFlashMessage(level, message, canClose) {
    if (level === 'error') {
        level = 'danger';
    }
    let template = '<div class="alert alert-' + level + '">';
    template += message;
    template += '</div>';
    $('#flashMessages').append(template);
}

function setFlashMessage(level, message, canClose = true) {
    clearFlashMessages();
    addFlashMessage(level, message, canClose);
}

function clearFlashMessages() {
    $('#flashMessages').html('');
}

function userIsLogged() {
    return new Promise((resolve, reject) => {
        fetch(API_ROUTES.IS_LOGGED, {
            method: 'GET',
        }).then(response => response.json()).then((data) => {
            if (data && data.isLogged === true) {
                resolve(true)
            } else {
                resolve(false)
            }
        }).catch((error) => {
            console.error('Error:', error)
            resolve(false)
        })
    })
}

function userRedirectLogin() {
    window.location.href = process.env.REACT_APP_HOST + '/common/login?red=' + encodeURIComponent(window.location.pathname)

}

// TODO : improve this hardcoded values
const DEVICES_LIST = [
    { name: 'R_SALON', label: 'SALON' },
    { name: 'R_BUREAU', label: 'BUREAU' },
    { name: 'R_CH-BUREAU', label: 'CH-BUREAU' },
    { name: 'R_CH-LUCIE', label: 'CH-LUCIE' },
    { name: 'R_CH-PARENTALE', label: 'CH-PARENTALE' },
    { name: 'O_SS', label: 'Sèche serviettes' },
    { name: 'MAIN', label: 'SHOGUN' },
    { name: 'SPA', label: 'SPA' },
]

// TODO : improve this hardcoded values
const DEVICES_LIST_SAUTER = [
    { name: 'RAD_SALON', label: 'SALON' },
    { name: 'RAD_CUISINE', label: 'CUISINE' },
    { name: 'RAD_COULOIR', label: 'COULOIR' },
    { name: 'RAD_CHAMBRE', label: 'CHAMBRE' },
    { name: 'HS_SS', label: 'Sèche serviettes' },
]

export {
    useTitle,
    API_ROUTES,
    setFlashMessage,
    clearFlashMessages,
    userIsLogged, 
    TRANS_SS_MODES,
    DEVICES_LIST,
    TRANS_SPA_MODES,
    DEVICES_LIST_SAUTER,
    TRANS_SS_MODES_SAUTER,
    userRedirectLogin
}